import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import { Button, InjectedFieldProps, useRecordContext, useResourceContext } from 'react-admin';
import { Link } from 'react-router-dom';

interface AddOne2ManyButtonProps extends InjectedFieldProps {
  basepath: string,
  label?: string,
  title?: string,
  icon?: React.ReactElement,
  defaultValues?: { [name: string]: any }
}

const AddOne2ManyButton = ({ basepath, label, title, icon, defaultValues }: AddOne2ManyButtonProps) => {
  const record = useRecordContext();
  const resource = useResourceContext();

  if (undefined === defaultValues) {
    defaultValues = {};
  }
  if (undefined === record) {
    return <>Please save.</>;
  }
  // const resource = listResource ?? props.resource;

  return (
    <>
      <Button
        component={Link}
        to={`/${basepath}/create?source=${JSON.stringify({ [`${resource}_id`]: record.id })}&ref=${resource}&ref_id=${undefined === record ? '' : record.id}${undefined === defaultValues ? '' : `&ref_default_values=${JSON.stringify(defaultValues)}`}`}
        label={label}
        title={title}
      >
        {icon}
      </Button>
    </>
  )
};

AddOne2ManyButton.defaultProps = {
  label: 'Add',
  title: 'Add',
  icon: <AddIcon />,
}

export default AddOne2ManyButton;
// export default withStyles(styles)(AddOne2ManyButton);
